export const TEAM_DASHBOARD_SECTION_FULLSCREEN_VIEW = "view";
export const TEAM_DASHBOARD_SECTION_FULLSCREEN_SCREENSHOTS = "screenshots";

/**
 * Clicking the same section again returns to the default dashboard layout.
 * Opening another section replaces the current fullscreen section.
 *
 * @param {string|null|undefined} current
 * @param {typeof TEAM_DASHBOARD_SECTION_FULLSCREEN_VIEW | typeof TEAM_DASHBOARD_SECTION_FULLSCREEN_SCREENSHOTS} section
 * @returns {string|null}
 */
export function toggleTeamDashboardSectionFullscreen(current, section) {
    if (section == null || section === "") {
        return current ?? null;
    }

    return current === section ? null : section;
}

/**
 * @param {string|null|undefined} current
 * @param {string} section
 * @returns {boolean}
 */
export function isTeamDashboardSectionFullscreen(current, section) {
    return current === section;
}

/**
 * Normalize a stored Team Dashboard section fullscreen value.
 *
 * @param {string|null|undefined} value
 * @returns {typeof TEAM_DASHBOARD_SECTION_FULLSCREEN_VIEW | typeof TEAM_DASHBOARD_SECTION_FULLSCREEN_SCREENSHOTS | null}
 */
export function resolveTeamDashboardSectionFullscreen(value) {
    if (value === TEAM_DASHBOARD_SECTION_FULLSCREEN_VIEW) {
        return TEAM_DASHBOARD_SECTION_FULLSCREEN_VIEW;
    }

    if (value === TEAM_DASHBOARD_SECTION_FULLSCREEN_SCREENSHOTS) {
        return TEAM_DASHBOARD_SECTION_FULLSCREEN_SCREENSHOTS;
    }

    return null;
}

/**
 * Stats bar and view panels (non-fullscreen header stack).
 */
export function shouldShowTeamDashboardMainTop(
    isViewFullscreen,
    isScreenshotsFullscreen,
) {
    return !isViewFullscreen && !isScreenshotsFullscreen;
}

/**
 * Team / Division dashboard tabs (StatsBar header) stay visible in section fullscreen.
 */
export function shouldShowTeamDashboardTabsBar(
    isViewFullscreen,
    isScreenshotsFullscreen,
    isTeamPanelDashboard = false,
    isTeamSectionExpanded = true,
) {
    // return isViewFullscreen || isScreenshotsFullscreen;
    const isFullscreen = isViewFullscreen || isScreenshotsFullscreen;
    if (!isFullscreen) return false;

    if (isTeamPanelDashboard && !isTeamSectionExpanded) return false;

    return true;
}

/**
 * Keep a single Screenshots instance mounted when toggling screenshots fullscreen.
 */
export function shouldShowTeamDashboardScreenshots(
    canShowScreenshots,
    isViewFullscreen,
    isScreenshotsFullscreen,
) {
    return (
        canShowScreenshots && (!isViewFullscreen || isScreenshotsFullscreen)
    );
}

/**
 * Whether to clear persisted screenshots fullscreen (and write null to storage).
 * Skips while assigners are not loaded yet — canShowScreenshots is false until then.
 *
 * @param {string|null|undefined} currentFullscreen
 * @param {boolean} canShowScreenshots
 * @param {unknown} assigners
 */
export function shouldClearTeamDashboardScreenshotsFullscreen(
    currentFullscreen,
    canShowScreenshots,
    assigners,
) {
    if (currentFullscreen !== TEAM_DASHBOARD_SECTION_FULLSCREEN_SCREENSHOTS) {
        return false;
    }

    if (canShowScreenshots) {
        return false;
    }

    if (assigners === undefined || assigners === null) {
        return false;
    }

    return true;
}
